import React, { useMemo } from 'react';

const SCORE_EVENTS = ['Home Run', 'Single', 'Double', 'Triple', 'Walk', 'Sac Fly', 'Field Error', 'Wild Pitch', 'Passed Ball'];

const TimelineItem = ({ play, isLast }) => {
  const event = play.result?.event || '--';
  const desc = play.result?.description || '';
  const inning = play.about?.inning;
  const isTop = play.about?.isTopInning;
  const rbi = play.result?.rbi || 0;
  const homeScore = play.result?.homeScore ?? play.about?.homeScore;
  const awayScore = play.result?.awayScore ?? play.about?.awayScore;
  const isHR = event === 'Home Run';

  return (
    <div className="flex gap-3 relative">
      <div className="flex flex-col items-center shrink-0 w-10">
        <div className={`w-3 h-3 rounded-full border-2 mt-1 shrink-0 ${isHR ? 'bg-[#c4333e] border-[#c4333e]' : rbi > 0 ? 'bg-[#d8ceb3] border-[#d8ceb3]' : 'bg-transparent border-[#658d71]'}`} />
        {!isLast && <div className="flex-1 w-px bg-[rgba(101,141,113,0.3)] mt-1" />}
      </div>
      <div className="pb-4 flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[9px] font-bold text-[#658d71] uppercase tracking-widest">
            {isTop ? '▲' : '▼'}{inning}
          </span>
          <span className={`text-[10px] font-black uppercase tracking-wider ${isHR ? 'text-[#c4333e]' : rbi > 0 ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>
            {event}
          </span>
          {rbi > 0 && (
            <span className="text-[9px] bg-[#c4333e] text-white px-1 font-bold">{rbi} RBI</span>
          )}
          {homeScore != null && awayScore != null && (
            <span className="text-[9px] text-[#658d71] font-bold ml-auto tabular-nums">
              {awayScore}–{homeScore}
            </span>
          )}
        </div>
        <p className="text-[10px] text-[#a9c9b1] leading-snug mt-0.5 line-clamp-2">{desc}</p>
      </div>
    </div>
  );
};

const RecapTimeline = ({ allPlays }) => {
  const scoringPlays = useMemo(() => {
    if (!allPlays?.length) return [];
    return allPlays.filter(p => {
      const rbi = p.result?.rbi ?? 0;
      const event = p.result?.event ?? '';
      return rbi > 0 || SCORE_EVENTS.some(e => event.includes(e) && rbi > 0) || event === 'Home Run';
    });
  }, [allPlays]);

  if (!scoringPlays.length) return (
    <div className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">No scoring plays available</div>
  );

  return (
    <div className="max-h-[340px] overflow-y-auto pr-1">
      {scoringPlays.map((play, i) => (
        <TimelineItem key={i} play={play} isLast={i === scoringPlays.length - 1} />
      ))}
    </div>
  );
};

export default RecapTimeline;